document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.accordion-item');

  // Initialize all accordions as closed
  accordionItems.forEach(item => {
    const content = item.querySelector('.faq-answer2');
    const opener = item.querySelector('.tab-opener');
    content.style.display = 'none';
    opener.style.setProperty('--accordion-indicator', '"+"');
  });

  // Add click event listeners
  accordionItems.forEach(item => {
    const opener = item.querySelector('.tab-opener');
    const content = item.querySelector('.faq-answer2');

    opener.addEventListener('click', () => {
      const isOpen = content.style.display === 'block';
      content.style.display = isOpen ? 'none' : 'block';
      
      // Update indicator using CSS custom property
      opener.style.setProperty('--accordion-indicator', isOpen ? '"+"' : '"-"');
    });
  });
}); 